import { useMemberPostStore } from '~/stores/memberPosts';

export class Refetch {
  async refetch() {
    const piniaMember = useMemberPostStore();
    await piniaMember[this._refetchUrl](this._refetchParams);
  }
}
